module.exports = __webpack_public_path__ + "img/my-ads-icon.b34f4786.svg";